import api from "../api/api";

interface generateVideoApiProps {
  task_id: string;
}

export const generateVideoApi = async (params: generateVideoApiProps) => {
  return await api.post("/api/status", params);
};
